import VideoSearch from './VideoSearch';

export * from './VideoSearch';
export default VideoSearch;
